/**
 * 车主证件
 */
export const IdCardTypeEnum = {
	/**
	 * 未知
	 */
	UNKNOWN: 0,
	/**
	 * 身份证
	 */
	ID_CARD: 1,
	/**
	 * 护照
	 */
	PASSPORT: 2,
	/**
	 * 军官证
	 */
	MILITARY_IDENTITY_CARD: 3,
	/**
	 * 台胞证
	 */
	TAIWAN_COMPATRIOT_ENTRY_PERMIT: 4,
	/**
	 * 香港身份证
	 */
	HONG_KONG_IDENTITY_CARD: 5,
	/**
	 * 澳门身份证
	 */
	MACAO_IDENTITY_CARD: 6,
	/**
	 * 企业社会信用代码
	 */
	ENTERPRISE_SOCIAL_CREDIT_CODE: 7
}

export const BrandEnum = {
	NIO: 'nio',
	ALPS: 'alps',
	FY: 'fy'
}

export const BrandMap = {
	[BrandEnum.NIO]: '蔚来',
	[BrandEnum.ALPS]: '乐道',
	[BrandEnum.FY]: '萤火虫'
}

export const BrandModuleCodeEnum = {
	[BrandEnum.NIO]: 10021,
	[BrandEnum.ALPS]: 18928,
	[BrandEnum.FY]: 18929
}

export const PatternType = {
	VIN: 'VIN',
	VID: 'VID',
	Name: 'NAME',
	CompanyName: 'COMPANY_NAME',
	Mobile: 'MOBILE',
	CommodityCode: 'COMMODITY_CODE'
}

export const validatorPattern = {
	[IdCardTypeEnum.ID_CARD]: /^[0-9]{17}[0-9xX]$/,
	[IdCardTypeEnum.PASSPORT]: /^[0-9A-Za-z]{1,18}$/,
	[IdCardTypeEnum.MILITARY_IDENTITY_CARD]: /^[0-9A-Za-z]{1,18}$/,
	[IdCardTypeEnum.TAIWAN_COMPATRIOT_ENTRY_PERMIT]: /^[0-9A-Za-z]{1,18}$/,
	[IdCardTypeEnum.HONG_KONG_IDENTITY_CARD]: /^[()a-zA-Z0-9]{1,18}$/,
	[IdCardTypeEnum.MACAO_IDENTITY_CARD]: /^[()a-zA-Z0-9]{1,18}$/,
	[IdCardTypeEnum.ENTERPRISE_SOCIAL_CREDIT_CODE]: /^[0-9A-Za-z]{1,18}$/,

	[PatternType.Mobile]: /^[0-9]{11}$/,
	[PatternType.VIN]: /^[0-9A-Za-z]+$/,
	[PatternType.VID]: /^[0-9A-Za-z]+$/,
	[PatternType.CommodityCode]: /^[0-9A-Za-z]+$/,
	[PatternType.Name]: /^[.\u4E00-\u9FA5a-zA-Z0-9\s（）()]{1,30}$/,
	[PatternType.CompanyName]: /^[\u4E00-\u9FA5a-zA-Z0-9\s（）()]{1,60}$/,
	[PatternType.CompanyName]: /^.{1,60}$/
}
